var _style, _path, _path2, _defs, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAKlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF5B00;}\n\t.st1{fill:#4D40CA;}\n\t.st2{clip-path:url(#SVGID_00000122722664002779982420000002229932915130757781_);fill:#00CBD0;}\n\t.st3{clip-path:url(#SVGID_00000122722664002779982420000002229932915130757781_);fill:#FFC200;}\n\t.st4{clip-path:url(#SVGID_00000122722664002779982420000002229932915130757781_);fill:#FF5B00;}\n\t.st5{clip-path:url(#SVGID_00000122722664002779982420000002229932915130757781_);fill:#4D40CA;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,195.2c2,0.9,4,1.7,6.1,2.4c4.4,1.4,5.1,0.8,3.1-3.1c-0.8-1.7-1.7-3.3-2.7-4.8c-1.9-3-3.3-4.1-6.3-1.5 c-0.6,0.5-1.2,1.1-1.7,1.7C87.3,191.9,87.3,193.6,90.7,195.2L90.7,195.2z M90.7,195.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135,280.2c-0.8-2.2-1.7-4.3-2.8-6.4c-2.3-4.4-3.2-4.4-4.7,0c-0.6,1.9-1.2,3.8-1.6,5.7 c-0.8,3.7-0.7,5.6,3.6,5.9c0.9,0.1,1.7,0.1,2.6,0C135.1,285.2,136.3,284,135,280.2L135,280.2z M135,280.2"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 81,
    y: 163.3,
    width: 438,
    height: 124.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100368901541934091390000015020842087919080066_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#00CBD0"
    },
    d: "M195.5,248 c-1.7-2-3.3-4.2-4.8-6.5c-3.1-4.9-2.6-5.8,2.7-4.8c2.3,0.4,4.4,1,6.6,1.7c4.2,1.3,5.9,2.5,3.8,7.1c-0.4,0.9-0.9,1.8-1.4,2.6 C200.6,251,198.5,251.6,195.5,248L195.5,248z M195.5,248"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#FFC200"
    },
    d: "M166.7,170.9 c-1.6,1.3-3.2,2.5-4.9,3.6c-3.7,2.3-4.4,1.9-3.6-2.1c0.3-1.7,0.8-3.3,1.3-5c1-3.2,1.9-4.5,5.4-2.9c0.7,0.3,1.3,0.7,2,1.1 C169,167.1,169.4,168.6,166.7,170.9L166.7,170.9z M166.7,170.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#00CBD0"
    },
    d: "M101.7,244.5 c-17.1,10.2-22.1-2.7-20.4-19.5c2.7-26.4,20.4-26.9,28.7-8C115,228.3,113.1,237.7,101.7,244.5L101.7,244.5z M101.7,244.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#FF5B00"
    },
    d: "M121.7,262.8 c0,2.9-0.1,5.7-0.3,8.5c-0.5,5.7-4.2,10.5-11.8,5.7c-3.1-2-6-4.2-8.8-6.6c-6.3-5.7-7.9-11.2,0-18.1c2-1.8,4.1-3.4,6.2-5 c9.9-7.4,13.7-2.4,14.4,8C121.6,257.7,121.7,260.2,121.7,262.8L121.7,262.8z M121.7,262.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#FFC200"
    },
    d: "M178.9,257.2 c-6.1-5.2-12.6-10-19.4-14.2c-14.6-9.2-17.4-7.7-14.3,8.2c1.3,6.7,3,13.3,5.1,19.7c4.1,12.5,7.7,17.7,21.3,11.4 c2.7-1.2,5.3-2.7,7.8-4.3C188.1,272.2,189.6,266.3,178.9,257.2L178.9,257.2z M178.9,257.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#FF5B00"
    },
    d: "M171.9,192.6 c-1.9,2.4-3.7,4.9-5.4,7.5c-10.3,15.1-9.2,15.7,5.4,22.1c5.3,2.3,10.7,4.3,16.2,6.1c20.3,6.4,23.4-0.7,17.5-18.4 c-1.7-5-4-9.7-6.9-14.1C189.7,182.3,182.3,178.9,171.9,192.6L171.9,192.6z M171.9,192.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000100368901541934091390000015020842087919080066_)",
      fill: "#4D40CA"
    },
    d: "M139.8,163.4 c-5.1,0.5-10,1.6-14.6,3.3c-12.7,4.5-10.8,9.8-3.8,19.9c1.4,2.1,2.9,4.1,4.5,6.2c8.1,10.7,10.3,13.1,16.9-2.1 c2.2-5,4.1-10.1,5.7-15.2C151.2,166.7,150.8,162.4,139.8,163.4L139.8,163.4z M139.8,163.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.8,206.1L480.7,227v-41.3c0-1.4-1.4-2.4-2.8-1.9l-9.8,3.7c-0.8,0.3-1.3,1.1-1.3,1.9v68.8c0,1.1,0.9,2,2,2 h9.8c1.1,0,2.1-0.9,2.1-2v-21.9l20.4,23.2c0.4,0.4,1,0.7,1.5,0.7h12.8c1.8,0,2.7-2.1,1.5-3.4l-22.7-25.5l20.9-22.5 c1.2-1.3,0.3-3.4-1.5-3.4h-12.4C500.8,205.4,500.2,205.7,499.8,206.1L499.8,206.1z M427.8,262c-15.9,0-28.8-13.5-28.8-30 c0-15.6,12.5-27.9,28.4-27.9c16.7,0,28.8,12.2,28.8,28.9C456.2,249.8,444.2,262,427.8,262L427.8,262z M428.2,249 c8.3,0,14.3-6.5,14.3-15.6c0-9.6-5.9-16.3-14.3-16.3c-8.8,0-14.9,6.5-14.9,15.7C413.3,242.1,419.7,249,428.2,249L428.2,249z  M362.2,262c-15.9,0-28.8-13.5-28.8-30c0-15.6,12.5-27.9,28.4-27.9c16.7,0,28.8,12.2,28.8,28.9C390.6,249.8,378.6,262,362.2,262 L362.2,262z M362.6,249c8.3,0,14.3-6.5,14.3-15.6c0-9.6-5.9-16.3-14.3-16.3c-8.8,0-14.9,6.5-14.9,15.7 C347.8,242.3,354,249,362.6,249L362.6,249z M308.8,258.5l0.1-69.2c0-0.9,0.5-1.6,1.3-1.9l9.6-3.6c1.3-0.5,2.8,0.5,2.8,1.9 l-0.1,72.8c0,1.1-0.9,2.1-2.1,2.1h-9.6C309.7,260.6,308.8,259.7,308.8,258.5L308.8,258.5z M282,206.1L262.9,227v-41.3 c0-1.4-1.4-2.4-2.8-1.9l-9.8,3.7c-0.8,0.3-1.3,1.1-1.3,1.9v68.8c0,1.1,0.9,2,2.1,2h9.8c1.1,0,2-0.9,2-2v-21.9l20.4,23.2 c0.4,0.4,1,0.7,1.5,0.7h12.8c1.8,0,2.7-2.1,1.5-3.4l-22.7-25.5l20.9-22.5c1.2-1.3,0.3-3.4-1.5-3.4h-12.4 C282.9,205.4,282.4,205.7,282,206.1L282,206.1z M282,206.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAKlook);
export default __webpack_public_path__ + "static/media/A-klook.599c1ac7f28b56e6ff5c5e95d4c709dc.svg";
export { ForwardRef as ReactComponent };